import cn from 'classnames';
import React from 'react';
import { ID, withCodes2 } from 'app/blocks/common/codes';
import SvgIcon from 'app/blocks/common/svg-icon/svg-icon';
import CheckboxButton from 'app/ui/form/CheckboxButton';
import PaymentAmountRow from './PaymentAmountRow';

import './PaymentAmountBreakdown.scss';

function PaymentAmountBreakdown(props) {
    const { chinaPayDetails, isOrderHistory, isSocopayDataCorrect, l, onSocopayAgreeChange, order } = props;
    const SocopaymentAgreement = () => (
        <div
            dangerouslySetInnerHTML={{ __html: l('LICENSE_SIGNING.PAYMENT.LABEL.SOCOPAY_POLICY_LINE') }}
            data-seleniumid="socopayPaymentAgreeCheckbox-label"
        />
    );

    return (
        <section className={cn('payment-panel', props.panelName)} data-seleniumid="order-price-panel-review">
            <div style={{ marginTop: '20px' }} />
            <div className="amount-rows">
                <PaymentAmountRow
                    amount={order.pricingDetails.basePrice}
                    bold
                    grayed={isOrderHistory}
                    seleniumid="base-price"
                    subHeader={`${l(
                        'ORDER_PANELS.PANEL_CHINA_PAY.PAYMENT_BREAKDOWN.ARTICLE_SUBMISSION_CHARGE_SUB_HEADER',
                    )}: ${order.article.type}`}
                    title={l('ORDER_PANELS.PANEL_CHINA_PAY.PAYMENT_BREAKDOWN.ARTICLE_SUBMISSION_CHARGE_HEADER')}
                />
                <PaymentAmountRow
                    amount={order.pricingDetails.discountAmount}
                    grayed={isOrderHistory}
                    seleniumid="discount"
                    title={l('ORDER_PANELS.PANEL_CHINA_PAY.PAYMENT_BREAKDOWN.DISCOUNT_HEADER')}
                />
                <PaymentAmountRow
                    amount={order.pricingDetails.totalAmount}
                    bold
                    grayed
                    seleniumid="sub-total"
                    title={l('ORDER_PANELS.PANEL_CHINA_PAY.PAYMENT_BREAKDOWN.SUBTOTAL_USD_HEADER')}
                />
                <PaymentAmountRow
                    amount={chinaPayDetails.subTotal}
                    currency="RMB"
                    grayed={isOrderHistory}
                    seleniumid="sub-total-rmb"
                    subHeader={`1 USD ≈ ${chinaPayDetails.conversionRate} CNY`}
                    title={l('ORDER_PANELS.PANEL_CHINA_PAY.PAYMENT_BREAKDOWN.SUBTOTAL_CNY_HEADER')}
                />
                <PaymentAmountRow
                    amount={chinaPayDetails.surcharge}
                    currency="RMB"
                    grayed={isOrderHistory}
                    seleniumid="surcharge-rmb"
                    title={l('ORDER_PANELS.PANEL_CHINA_PAY.PAYMENT_BREAKDOWN.SURCHARD_HEADER')}
                />
                <PaymentAmountRow
                    amount={chinaPayDetails.tax}
                    currency="RMB"
                    grayed={isOrderHistory}
                    seleniumid="tax-rmb"
                    title={l('ORDER_PANELS.PANEL_CHINA_PAY.PAYMENT_BREAKDOWN.TAX_HEADER')}
                />
                <PaymentAmountRow
                    amount={chinaPayDetails.finalPrice}
                    blue={!isOrderHistory}
                    bold
                    currency="RMB"
                    grayed={isOrderHistory}
                    seleniumid="final-price-rmb"
                    title={l('ORDER_PANELS.PANEL_CHINA_PAY.PAYMENT_BREAKDOWN.ORDER_TOTAL_HEADER')}
                />
                {!isOrderHistory && (
                    <div>
                        <div className="payment-PayViaSocopay">
                            <span data-seleniumid="payment-pay-via-socopay-label">
                                {l('ORDER_PANELS.PANEL_CHINA_PAY.SOCOPAY_PAY_TITLE')}
                            </span>
                            <SvgIcon.alipayLogo className="SocopayText-Icon" seleniumid="payment-pay-via-alipay-logo" />
                            <SvgIcon.weChatPayLogo
                                className="SocopayText-Icon"
                                seleniumid="payment-pay-via-weChatPay-logo"
                            />
                            <SvgIcon.unionPayLogo
                                className="SocopayText-Icon"
                                seleniumid="payment-pay-via-unionPay-logo"
                            />
                        </div>
                        <div>
                            <span
                                className="payment-PayViaSocopay-verifyTxt"
                                data-seleniumid="socopay-payment-socopay-description"
                            >
                                {l('ORDER_PANELS.PANEL_CHINA_PAY.SOCOPAY_PAY_SUBTITLE')}
                            </span>
                            <br /> <br />
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: l('ORDER_PANELS.PANEL_CHINA_PAY.SOCOPAY_PAY_DESCRIPTION'),
                                }}
                                data-seleniumid="socopay-payment-mobile-description"
                            />
                        </div>
                        <CheckboxButton
                            checked={isSocopayDataCorrect}
                            className="payment-AcceptCheckBox"
                            data-seleniumid="socopayPaymentAgreeCheckbox"
                            id="socopayAgreeCheckbox"
                            label={<SocopaymentAgreement />}
                            onChange={event => onSocopayAgreeChange(event.target.checked)}
                        />
                    </div>
                )}
            </div>
        </section>
    );
}

export default withCodes2(ID.ORDER_PANELS, ID.LICENSE_SIGNING)(PaymentAmountBreakdown);
